<template>
  <sliderBarDialogShell
    :click-not-close="true"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="add-pushRule-dialog"
  >
    <push-rule-form
      ref="outform"
      @submit="submit"
    ></push-rule-form>
  </sliderBarDialogShell>
</template>

<script>
import { saveMessagePushRule } from '@/api/sys/messagePushRule'
import pushRuleForm from "@/components/sys/messagePushRule/pushRuleForm";

export default {
  name: "addPushRuleDialog",
  components: {
    pushRuleForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: '新增推送规则'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(formData) {
      let params = {
        ruleName: formData.ruleName,
        strategyId: formData.strategyId,
        channelType: formData.pushChannel,
        senderId: formData.pushConfig,
        titlePrefix: formData.titlePrefix,
        status: formData.status,
        expireDate: formData.expireDate,
        receiverId:formData.receiverId
      }
      if(formData.pushChannel == 1){
        params.receiverId = JSON.stringify(formData.peopleTag);
      }else if(formData.pushChannel== 2 || formData.pushChannel== 3){
        params.receiverId = formData.peopleGroupNo;
      }else if(formData.pushChannel == 5){
        params.receiverId = JSON.stringify({type:formData.peopleType,ids:formData.peopleIds});
      }
      saveMessagePushRule(params).then((res) => {
        if(res && res.code===200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$emit('add-success');
          this.$refs.outform.selfClear();
        }else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }

      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-pushRule-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
